var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "mobile-bottom-nav",
      attrs: { "aria-label": _vm.$t("nav.portal-navigation") }
    },
    [
      _vm._l(_vm.primaryLinks, function(link) {
        return _c(
          "button",
          {
            key: link.route,
            staticClass: "mobile-nav-action",
            class: { "is-active": _vm.isActive(link) },
            attrs: {
              type: "button",
              "aria-current": _vm.isActive(link) ? "page" : null
            },
            on: {
              click: function($event) {
                return _vm.handleClick(link)
              }
            }
          },
          [
            link.customIcon
              ? _c("custom-page-icon", { attrs: { name: link.icon, size: 22 } })
              : _c("portal-icon", { attrs: { name: link.icon, size: 22 } }),
            _c("span", [_vm._v(_vm._s(link.label))])
          ],
          1
        )
      }),
      _c(
        "v-menu",
        {
          attrs: {
            top: "",
            left: "",
            "offset-y": "",
            "content-class": "mobile-more-surface",
            "close-on-content-click": false
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "button",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass: "mobile-nav-action",
                          class: { "is-active": _vm.overflowIsActive },
                          attrs: {
                            type: "button",
                            "aria-label": _vm.$t("global.more")
                          }
                        },
                        "button",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("portal-icon", { attrs: { name: "menu", size: 22 } }),
                      _c("span", [_vm._v(_vm._s(_vm.$t("global.more")))])
                    ],
                    1
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.menuOpen,
            callback: function($$v) {
              _vm.menuOpen = $$v
            },
            expression: "menuOpen"
          }
        },
        [
          _c("div", { staticClass: "mobile-more-menu" }, [
            _c(
              "div",
              { staticClass: "mobile-destination-list" },
              [
                _vm._l(_vm.allLinks, function(link) {
                  return [
                    _c(
                      "button",
                      {
                        key: link.route || link.hyperLink,
                        staticClass: "mobile-destination",
                        class: { "is-active": _vm.isActive(link) },
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.handleClick(link)
                          }
                        }
                      },
                      [
                        link.customIcon
                          ? _c("custom-page-icon", {
                              attrs: { name: link.icon, size: 21 }
                            })
                          : _c("portal-icon", {
                              attrs: { name: link.icon, size: 21 }
                            }),
                        _c("span", [_vm._v(_vm._s(link.label))]),
                        link.hyperLink
                          ? _c("portal-icon", {
                              attrs: { name: "external-link", size: 16 }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._l(link.tabs || [], function(tab) {
                      return _c(
                        "button",
                        {
                          key: link.route + "-" + tab.route,
                          staticClass: "mobile-subdestination",
                          class: {
                            "is-active": _vm.$route.fullPath === tab.route
                          },
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.goTo(tab.route)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(tab.label) + " ")]
                      )
                    })
                  ]
                })
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "mobile-settings" },
              [_c("settings-nav")],
              1
            ),
            _c(
              "button",
              {
                staticClass: "mobile-logout",
                attrs: { type: "button" },
                on: { click: _vm.confirmLogout }
              },
              [
                _c("portal-icon", { attrs: { name: "log-out", size: 20 } }),
                _c("span", [_vm._v(_vm._s(_vm.$t("nav.logout")))])
              ],
              1
            )
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }